export const handleChangeDataUserOrders = (name, value) => ({
    type: 'CHANGE_DATA_USER_ORDERS', name, value
});